import React from 'react';
import { HeartIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { closingLines, guarantees } from '../data/content';
export function FinalCta() {
  return <section aria-labelledby="cierre-title" className="w-full bg-cream-200 px-5 py-20 sm:py-24" data-id="element-53" data-mp="19epavnbuswvf">
      <div className="mx-auto max-w-content" data-id="element-54" data-mp="15dlv10tt30u7">
        <div className="grid gap-12 lg:grid-cols-2" data-id="element-55" data-mp="15ckg2l9o5u77">
          <div className="text-center sm:text-left" data-id="element-56" data-mp="1jcvatze3nsxn">
            <h2 id="cierre-title" className="font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-5xl" data-id="element-57" data-mp="1jbk4psx6m93d">
              La próxima semana podrías seguir exactamente donde estás.
            </h2>
            <p className="mt-4 font-display text-3xl italic text-rose-500 sm:text-4xl" data-id="element-58" data-mp="1o3lg7cmizvsc">
              O podrías haber empezado el proceso que cambia todo.
            </p>
          </div>

          <ul className="space-y-3 self-center" data-id="element-59" data-mp="1x51q7j9fhvw1">
            {closingLines.map(line => <li key={line} className="flex items-start gap-3 text-base text-plum-500" data-id="element-60" data-mp="n64b3n7yhqle">
                <span aria-hidden="true" className="mt-1 text-rose-400" data-id="element-61" data-mp="s4flbz25y345">
                  ▸
                </span>
                {line}
              </li>)}
          </ul>
        </div>

        <div className="mt-16 max-w-2xl space-y-4 text-lg leading-relaxed text-plum-500" data-id="element-62" data-mp="122lm2dc8h37f">
          <p data-id="element-63" data-mp="164gmlfmcbck5">El Sistema Después de Él no te hace más fuerte.</p>
          <p className="font-display text-3xl font-semibold text-plum-800" data-id="element-64" data-mp="163xboiv3xofm">Ya eres fuerte.</p>
          <p data-id="element-65" data-mp="1b1yvx749rtso">
            Lo que hace es darte el mapa, el plan y las herramientas para que esa fuerza finalmente
            tenga una dirección.
          </p>
          <p data-id="element-66" data-mp="1ktw7wg33qpsg">Esa dirección tiene un nombre.</p>
          <p className="font-display text-4xl font-semibold italic text-rose-500" data-id="element-67" data-mp="1ksl62lt7vs3z">
            Se llama libertad.
          </p>
        </div>

        <blockquote className="mt-16 border-l-2 border-rose-300 pl-6 font-display text-2xl italic leading-snug text-plum-700 sm:text-3xl" data-id="element-68" data-mp="1ttro4zbilazc">
          “El mejor momento para tener este sistema era antes de que el ciclo empezara. El segundo
          mejor momento es hoy.”
        </blockquote>

        <div className="mt-16 border-t border-rose-200 pt-14 text-center" data-id="element-69" data-mp="3hcsbeg0p70w">
          <p className="inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-rose-600" data-id="element-70" data-mp="3jpkekfhoxro">
            <HeartIcon aria-hidden="true" className="h-3.5 w-3.5 fill-rose-400 text-rose-400" data-id="element-71" data-mp="ddxyi33rwo6b" />
            Sistema Después de Él
          </p>
          <p className="mx-auto mt-6 max-w-2xl font-display text-3xl font-semibold leading-snug text-plum-800 sm:text-4xl" data-id="element-72" data-mp="mg76ombkk5gj">
            De atrapada y agotada a libre, clara y completamente dueña de tu vida.
          </p>
          <div className="mt-9 flex justify-center" data-id="element-73" data-mp="2o728pvwdd0vp">
            <CtaButton data-id="element-74" data-mp="2o9nakkwo3gtg">Quiero empezar mi proceso ahora</CtaButton>
          </div>
          <p className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-1 text-sm text-plum-400" data-id="element-75" data-mp="2k81p4b62hu7n">
            {guarantees.map(item => <span key={item} data-id="element-76" data-mp="2e3nf835cvsox">✅ {item}</span>)}
          </p>
        </div>
      </div>
    </section>;
}